import React, { Component } from 'react';
import BottomButton from 'forms/BottomButton/link';
import DeviceInfo from 'devices/DeviceInfo';
import Box from 'common/Box';
import PlanInfo from 'insurance/insurancePlans/PlanInfo';
import styles from './InsuranceInfo.module.css';

class InsuranceInfo extends Component {
  componentDidMount() {
    this.fetchContract();
    this.fetchInsuredDevice();
  }

  componentDidUpdate(oldProps) {
    const { subId, contractId, contract, fetchContractStatus, insuredDevice, fetchDeviceStatus, subRoute } = this.props;
    if (subId !== oldProps.subId) {
      this.fetchContract();
    } 
    if (contractId !== oldProps.contractId) {
      this.fetchInsuredDevice();
    }

    const loadedContract = fetchContractStatus === 'SUCCEEDED';
    if (loadedContract && oldProps.fetchContractStatus !== fetchContractStatus && !contract) {
      subRoute(subId);
    }

    const loadedDevice = fetchDeviceStatus === 'SUCCEEDED';
    if (loadedContract && loadedDevice && oldProps.fetchDeviceStatus !== fetchDeviceStatus && !insuredDevice) {
      subRoute(subId);
    }
  }

  fetchContract = () => {
    const { subId, fetchFilteredInsuranceContracts, filter } = this.props;
    const tranformedFilter = filter === 'bypassedSubscription' ? 'bypassed_subscription' : filter;
    subId && fetchFilteredInsuranceContracts({ [tranformedFilter]: subId });
  }
  fetchInsuredDevice = () => {
    const { contract, fetchFilteredInsuredDevices } = this.props;
    contract && fetchFilteredInsuredDevices({ contract: contract.id });
  }

  render() {
    const { insuredDevice, insurancePlan } = this.props;
    if (!insuredDevice || !insurancePlan) { return null; }

    return (
      <div>
        <DeviceInfo deviceId={insuredDevice.device_specs} />

        <Box className={styles.makeClaim}>
          <PlanInfo insurancePlan={insurancePlan} />
          <BottomButton href="https://onlineportal-us.likewize.com/wingatt" target="_blank">Make a Claim</BottomButton>
        </Box>
      </div>
    )
  }
}

export default InsuranceInfo;
